import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { ChromePicker } from 'react-color';
import { Card, CardContent, DialogContent } from '@material-ui/core';
import { Button, Dialog } from '@knockrentals/knock-shared-web-v2';
import { ColorSwatch } from '../../../../../../../../../Components/Icons';
import { makeCss } from '../../../../../../../../../knock-design-system';

const useCss = makeCss({
  dialogContent: {
    paddingBottom: '8px',
  },
  colorDisplayWrapper: {
    display: 'inline-block',
    marginLeft: '24px',
    textAlign: 'center',
  },
  colorPickerCard: {
    '& .chrome-picker': {
      display: 'inline-block',
    },
  },
  colorSwatch: {
    height: '120px',
    width: '120px',
    zIndex: 'unset',
  },
  pickerActions: {
    justifyContent: 'flex-end',
  },
  pickerCardContent: {
    backgroundColor: '#F7F7F8',
    padding: '24px',
    textAlign: 'center',
  },
});

const ColorPickerCard = ({ color = '', onCancel, onConfirmColor }) => {
  const [selectedColor, setSelectedColor] = useState(color);
  const css = useCss();

  const handleChange = (pickerColor) => {
    setSelectedColor(pickerColor.hex);
  };

  const handleRemoveOnClick = () => {
    setSelectedColor('');
  };

  const handleConfirmOnClick = () => {
    onConfirmColor(selectedColor);
  };

  const isConfirmButtonDisabled =
    selectedColor.toLowerCase() === color.toLowerCase();

  return (
    <React.Fragment>
      <DialogContent css={css.dialogContent}>
        <Card css={css.colorPickerCard}>
          <CardContent css={css.pickerCardContent}>
            <ChromePicker
              color={selectedColor || ''}
              disableAlpha={true}
              onChangeComplete={handleChange}
            />

            <div css={css.colorDisplayWrapper}>
              <ColorSwatch css={css.colorSwatch} color={selectedColor} />

              <div>
                <Button
                  disabled={!selectedColor}
                  color="primary"
                  onClick={handleRemoveOnClick}
                  variant="text"
                >
                  remove color
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </DialogContent>

      <Dialog.Actions css={css.pickerActions}>
        <Button onClick={onCancel} variant="outlined">
          Cancel
        </Button>

        <Button
          disabled={isConfirmButtonDisabled}
          onClick={handleConfirmOnClick}
        >
          Ok
        </Button>
      </Dialog.Actions>
    </React.Fragment>
  );
};

ColorPickerCard.propTypes = {
  color: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirmColor: PropTypes.func,
};

export default ColorPickerCard;
